import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import { alpha } from "@mui/material/styles";
import { Link } from "react-router-dom";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import EmailIcon from "@mui/icons-material/Email";

const footerLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Projects", path: "/project" },
  { label: "Resume", path: "/resume" },
  { label: "Freelance", path: "/social-proof" },
];

const socialLinks = [
  { icon: <GitHubIcon />, url: "https://github.com/ahmadit575", label: "GitHub" },
  { icon: <LinkedInIcon />, url: "https://linkedin.com/in/rahmanidrees", label: "LinkedIn" },
  { icon: <TwitterIcon />, url: "https://twitter.com/rahmanidrees", label: "Twitter" },
  { icon: <EmailIcon />, url: "mailto:rahmanidrees11@gmail.com", label: "Email" },
];

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        mt: "auto",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: "10%",
          right: "10%",
          height: 1,
          pointerEvents: "none",
          background: (theme) =>
            `linear-gradient(90deg, transparent, ${alpha(
              theme.palette.primary.main,
              0.3
            )}, transparent)`,
        },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between">
          {/* Brand Section */}
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: 2,
                    background: (theme) =>
                      `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography sx={{ color: "white", fontWeight: 700, fontSize: "1rem" }}>
                    R
                  </Typography>
                </Box>
                <Typography variant="h6" fontWeight={700}>
                  Rahman Idrees
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 300 }}>
                Enterprise SaaS Developer building MERN platforms, Oracle Fusion API
                integrations, invoicing and accounting systems, dashboards, and Web3 DApps.
              </Typography>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 2 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {footerLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  style={{ textDecoration: "none" }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      display: "inline-block",
                      transition: "color 0.2s ease",
                      "&:hover": {
                        color: "primary.main",
                        cursor: "pointer",
                      },
                    }}
                  >
                    {link.label}
                  </Typography>
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Contact */}
          <Grid item xs={6} md={3}>
            <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 2 }}>
              Get In Touch
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Have a SaaS, Oracle Fusion, accounting, dashboard, or Web3 project in mind?
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              {socialLinks.map((social) => (
                <IconButton
                  key={social.label}
                  component="a"
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  size="small"
                  sx={{
                    color: "text.secondary",
                    border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                    "&:hover": {
                      color: "primary.main",
                      borderColor: "primary.main",
                      backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
                    },
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: (theme) => alpha(theme.palette.divider, 0.1) }} />

        {/* Bottom Bar */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Copyright {currentYear} Rahman Idrees. All rights reserved.
          </Typography>
          {/* <Typography
            variant="body2"
            color="text.secondary"
            sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
          >
            Built with{" "}
            <FavoriteIcon sx={{ fontSize: 14, color: "error.main" }} />{" "}
            using React & MUI
          </Typography> */}
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
